var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_843_1200)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_843_1200)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.5338 1.66406C11.9254 1.66406 12.2504 1.98073 12.2504 2.38073V17.6224C12.2504 18.0141 11.9338 18.3391 11.5338 18.3391C6.62544 18.3391 3.20044 14.9141 3.20044 10.0057C3.20044 5.0974 6.63377 1.66406 11.5338 1.66406Z",
    fill: "#1D453F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6164 9.61875L15.2497 7.24375C15.0081 7.00208 14.6081 7.00208 14.3664 7.24375C14.1247 7.48542 14.1247 7.88542 14.3664 8.12708L15.6664 9.42708H7.69141C7.34974 9.42708 7.06641 9.71042 7.06641 10.0521C7.06641 10.3938 7.34974 10.6771 7.69141 10.6771H15.6664L14.3664 11.9771C14.1247 12.2188 14.1247 12.6188 14.3664 12.8604C14.4914 12.9854 14.6497 13.0438 14.8081 13.0438C14.9664 13.0438 15.1247 12.9854 15.2497 12.8604L17.6164 10.4854C17.8581 10.2521 17.8581 9.86042 17.6164 9.61875Z",
    fill: "#1D453F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_843_1200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_843_1200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout01);
export default __webpack_public_path__ + "static/media/logout_01.be912d9e9a735d70748007180c9c67a7.svg";
export { ForwardRef as ReactComponent };